import React, { useState, useEffect } from "react";
import "../CorporateProfile/style.scss";
import Modal from "react-modal";
import Slider from "react-slick";

const CsrModal = (props) => {
  const { open, onClose, content } = props;

  const [index, setIndex] = useState(0);
  const handleSelect = (selectedIndex, e) => {
    setIndex(selectedIndex);
  };

  const settings = {
    dots: true,
    autoplay: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1
  }

  return (
    <div>
      <Modal
        isOpen={open}
        onRequestClose={onClose}
        contentLabel="Example Modal"
        className="csrModalHead"
      >
        <div className="csrmodal">
          <div className="d-flex pb-3 align-items-center justify-content-between modalheader">
            <h2 className="modaltitle">{content.name}</h2>
            {/* <img
              onClick={onClose}
              src="/images/New/close-circleclose.svg"
              className="csrclose"
            /> */}
            <svg width="35" height="35" viewBox="0 0 44 48" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={onClose}>
              <path d="M21.9998 43.6982C32.0832 43.6982 40.3332 34.9527 40.3332 24.2638C40.3332 13.5749 32.0832 4.82947 21.9998 4.82947C11.9165 4.82947 3.6665 13.5749 3.6665 24.2638C3.6665 34.9527 11.9165 43.6982 21.9998 43.6982Z" fill="#F6F6F6" />
              <path d="M16.8115 29.7638L27.1882 18.7639" stroke="#444444" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M27.1882 29.7638L16.8115 18.7639" stroke="#444444" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </div>
          <div className="modalbody">          
          <Slider {...settings}>
            {
              content &&
              content.image &&
              content.image.file &&
              content.image.file.length > 0 &&
              content.image.file.map((item, index) => (
                <div className="carousalitem">
                  <img className="d-block mx-auto" src={item.url} alt="" />
                </div>
                  
                
              ))
            }

          </Slider>

          <div className="imgdetail p-4">
            {content && content.description ? (
              <div
                dangerouslySetInnerHTML={{
                  __html: content.description,
                }}
              />
            ) : null}
          </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default CsrModal;
